module.exports = __webpack_public_path__ + "img/Support-skill-229.8969e6fb.png";